// Every face and landing modifier is expressed in player HP, never hit points
// on a separate probability scale. Keep profiles shared by rules and renderer.
export const CORE_MASSIVE_ATTACK_BONUS = 3;

export const CORE_ATTACKS = [
  {
    name: 'Static barrage',
    faces: [1, 2, 3, 3, 4, 5],
    heal: 0,
    description: 'A steady damage die. Shields and Guard reduce the result.',
  },
  {
    name: 'Worldbreaker',
    faces: [2, 3, 4, 5, 6, 7],
    heal: 0,
    description:
      'A heavy damage die. Prepare shields or Guard before throwing.',
  },
  {
    name: 'Siphon pulse',
    faces: [0, 1, 2, 2, 3, 4],
    heal: 80,
    description:
      'A lighter damage die. Removing your HP restores up to 80 Core HP; full blocks and decoys stop the healing.',
  },
];
export const getCoreDamageFaces = (round = 1, enraged = false) =>
  CORE_ATTACKS[Math.max(0, round - 1) % CORE_ATTACKS.length].faces.map(
    (face) => face + (enraged ? 2 : 0)
  );
export const rollCoreDamage = (faces, random = Math.random) =>
  faces[Math.min(5, Math.max(0, Math.floor(random() * 6)))];
export const isCoreDamageRoll = (value, faces) =>
  Number.isInteger(value) && faces.includes(value);
